
// ----------------------------------------------------
// Timeline
// ----------------------------------------------------

export const TIME_START = {
  H: 12,
  M: 30,
};

export const TIMELINE = [
  {
    pos: 0.05,
    posLimits: {
      min: 0,
      max: 0.08,
    },
    section: 'INTRO',
  },
  {
    pos: 0.1,
    posLimits: {
      min: 0.08,
      max: 0.12,
    },
    time: 0,
    timeline: {
      top: [
        {
          ico: 'case',
          video: '32843',
          hilite: '0-0',
        },
      ],
      bottom: [
        {
          ico: 'helmet',
          video: '32842',
          hilite: '0-1',
        },
      ],
    },
    map: {
      top: [
        {
          hidden: true,
          hiliteId: '0-0',
          label: '',
          ico: 'case',
          color: '#8396cc',
          pos: {
            x: -589,
            y: 175,
          },
        },
      ],
      bottom: [
        {
          hiliteId: '0-0',
          label: 'Situation in\u00a0the\u00a0mine',
          ico: 'case',
          color: '#677593',
          pos: {
            x: 642,
            y: 258,
          },
        },
        {
          hiliteId: '0-1',
          label: 'Cause of\u00a0the\u00a0disaster',
          ico: 'helmet',
          color: '#b3403a',
          pos: {
            x: 565,
            y: 314,
          },
        },
      ],
    },
  },
  {
    pos: 0.3,
    posLimits: {
      min: 0.28,
      max: 0.32,
    },
    time: 180,
    timeline: {
      top: [
        {
          ico: 'case',
          video: '32849',
          hilite: '1-0',
        },
      ],
      bottom: [
        {
          ico: 'helmet',
          video: '32844',
          hilite: '1-1',
        },
      ],
    },
    map: {
      top: [
        {
          hidden: true,
          hiliteId: '1-0',
          label: '',
          ico: 'case',
          color: '#8396cc',
          pos: {
            x: -589,
            y: 175,
          },
        },
      ],
      bottom: [
        {
          hiliteId: '1-0',
          label: 'The\u00a0first report',
          ico: 'case',
          color: '#677593',
          pos: {
            x: 537,
            y: 337,
          },
        },
        {
          hiliteId: '1-1',
          label: 'Miners sense an\u00a0odour',
          ico: 'helmet',
          color: '#b3403a',
          pos: {
            x: 474,
            y: 372,
          },
        },
      ],
    },
  },
  {
    pos: 0.39,
    posLimits: {
      min: 0.37,
      max: 0.41,
    },
    time: 240,
    timeline: {
      top: [
        {
          ico: 'case',
          video: '32851',
          hilite: '2-0',
        },
      ],
      bottom: [
        {
          ico: 'helmet',
          video: '32850',
          hilite: '2-1',
        },
      ],
    },
    map: {
      top: [
        {
          hiliteId: '2-0',
          label: 'Underestimated alerts',
          ico: 'case',
          color: '#8396cc',
          pos: {
            x: -589,
            y: 175,
          },
        },
      ],
      bottom: [
        {
          hiliteId: '2-1',
          label: 'Smoke near the\u00a0shallow shaft',
          ico: 'helmet',
          color: '#b3403a',
          pos: {
            x: 334,
            y: 325,
          },
        },
        {
          hiliteId: '2-1',
          hidden: true,
          label: '',
          ico: 'helmet',
          color: '#b3403a',
          pos: {
            x: 445,
            y: 400,
          },
        },
      ],
    },
  },
  {
    pos: 0.44,
    posLimits: {
      min: 0.42,
      max: 0.46,
    },
    time: 274,
    timeline: {
      top: [
        {
          ico: 'case',
          video: '32854',
          hilite: '3-0',
        },
      ],
      bottom: [
        {
          ico: 'helmet',
          video: '32852',
          hilite: '3-1',
        },
        {
          ico: 'helmet',
          video: '32853',
          hilite: '3-2',
        },
      ],
    },
    map: {
      top: [
        {
          hidden: true,
          hiliteId: '3-0',
          label: '',
          ico: 'case',
          color: '#8396cc',
          pos: {
            x: -589,
            y: 175,
          },
        },
      ],
      bottom: [
        {
          hiliteId: '3-0',
          label: 'Examining the\u00a0situation',
          ico: 'case',
          color: '#677593',
          pos: {
            x: 606,
            y: 300,
          },
        },
        {
          hiliteId: '3-1',
          hidden: true,
          label: '',
          ico: 'helmet',
          color: '#b3403a',
          pos: {
            x: 729,
            y: 168,
          },
        },
        {
          hiliteId: '3-1',
          label: 'Situation in\u00a0the\u00a011<sup>th</sup> seam',
          ico: 'helmet',
          color: '#b3403a',
          pos: {
            x: 752,
            y: 217,
          },
        },
        {
          hiliteId: '3-2',
          label: 'Situation in\u00a0the\u00a08<sup>th</sup> seam',
          ico: 'helmet',
          color: '#c84c52',
          pos: {
            x: 484,
            y: 226,
          },
        },
      ],
    },
  },
  {
    pos: 0.48,
    posLimits: {
      min: 0.46,
      max: 0.5,
    },
    time: 290,
    timeline: {
      top: [
        {
          ico: 'case',
          video: '32856',
          hilite: '4-0',
        },
        {
          ico: 'case',
          video: '32857',
          hilite: '4-1',
        },
      ],
      bottom: [
        {
          ico: 'helmet',
          video: '32855',
          hilite: '4-2',
        },
      ],
    },
    map: {
      top: [
        {
          hiliteId: '4-0',
          label: 'Rescuers arrive',
          ico: 'case',
          color: '#8396cc',
          pos: {
            x: -310,
            y: 180,
          },
        },
        {
          hidden: true,
          hiliteId: '4-1',
          label: '',
          ico: 'case',
          color: '#8396cc',
          pos: {
            x: -589,
            y: 175,
          },
        },
      ],
      bottom: [
        {
          hiliteId: '4-1',
          label: 'Smoke in\u00a0the\u00a08<sup>th</sup> seam',
          ico: 'case',
          color: '#677593',
          pos: {
            x: 544,
            y: 317,
          },
        },
        {
          hiliteId: '4-2',
          label: 'Abandoning the\u00a08<sup>th</sup> seam',
          ico: 'helmet',
          color: '#b3403a',
          pos: {
            x: 654,
            y: 179,
          },
        },
      ],
    },
  },
  {
    pos: 0.55,
    posLimits: {
      min: 0.53,
      max: 0.57,
    },
    time: 330,
    timeline: {
      top: [
        {
          ico: 'case',
          video: '32859',
          hilite: '5-0',
        },
      ],
      bottom: [
        {
          ico: 'helmet',
          video: '32858',
          hilite: '5-1',
        },
      ],
    },
    map: {
      top: [
        {
          hidden: true,
          hiliteId: '5-0',
          label: '',
          ico: 'case',
          color: '#8396cc',
          pos: {
            x: -589,
            y: 175,
          },
        },
      ],
      bottom: [
        {
          hiliteId: '5-0',
          label: 'The\u00a0last contact',
          ico: 'case',
          color: '#677593',
          pos: {
            x: 776,
            y: 152,
          },
        },
        {
          hiliteId: '5-1',
          label: 'Death in\u00a0the\u00a0mine',
          ico: 'helmet',
          color: '#b3403a',
          pos: {
            x: 574,
            y: 280,
          },
        },
      ],
    },
  },
  {
    pos: 0.77,
    posLimits: {
      min: 0.75,
      max: 0.79,
    },
    time: 540,
    timeline: {
      top: [
        {
          ico: 'case',
          video: '32861',
          hilite: '6-0',
        },
      ],
      bottom: [
        {
          ico: 'helmet',
          video: '32860',
          hilite: '6-1',
        },
      ],
    },
    map: {
      top: [
        {
          hiliteId: '6-0',
          label: 'Evacuation',
          ico: 'case',
          color: '#8396cc',
          pos: {
            x: -589,
            y: 175,
          },
        },
      ],
      bottom: [
        {
          hiliteId: '6-1',
          label: 'Risk of\u00a0explosion',
          ico: 'helmet',
          color: '#b3403a',
          pos: {
            x: 508,
            y: 318,
          },
        },
      ],
    },
  },
  {
    pos: 0.9,
    posLimits: {
      min: 0.88,
      max: 0.92,
    },
    time: 635,
    timeline: {
      top: [
        {
          ico: 'case',
          video: '32862',
          hilite: '7-0',
        },
      ],
      bottom: [],
    },
    map: {
      top: [
        {
          hiliteId: '7-0',
          label: 'End of\u00a0all\u00a0hope',
          ico: 'case',
          color: '#8396cc',
          pos: {
            x: -589,
            y: 175,
          },
        },
      ],
      bottom: [],
    },
  },
  {
    pos: 0.95,
    posLimits: {
      min: 0.92,
      max: 1,
    },
    section: 'OUTRO',
  },
];

// ----------------------------------------------------
// Scenes
// ----------------------------------------------------

export const SCENE_TOP = {
  LIMIT_1: {
    MIN: 0.1,
    MAX: 0.5,
  },
  LIMIT_2: {
    MIN: 0.55,
    MAX: 0.63,
  },
  LIMIT_3: {
    MIN: 0.63,
    MAX: 0.8,
  },
};

export const SMOKE_DAY = {
  MAX_Y: -250,
  BASE_ALPHA: 0.7,
  MIN: 0.5,
  MAX: 0.65,
};

export const SCENE_BOTTOM = {
  FIRE: [0.35, 0.4, 0.455, 0.516, 0.75, 0.95],
};

// ----------------------------------------------------
// Sub-Sections
// ----------------------------------------------------

export const SUB_SECTION_VIDEO = {
  INTRO: '32841',
  OUTRO: '32863',
};

// ----------------------------------------------------
// Links
// ----------------------------------------------------

export const LINKS = {
  MOVIE: '//www.ceskatelevize.cz/porady/11490475387-dukla-61/',
  DOCUMENT: '//www.ceskatelevize.cz/porady/12107497654-cerne-zlato/',
};



// WEBPACK FOOTER //
// ./src/content.js